import '../../../styles/Auth/categoryPopup.css';
const ViewsubCategoryPopup = ({ data, onClose }) => {
    return (
        <div className="view-popup-overlay">
            <div className="view-popup-wrapper">

                <div className="subcategory-view-popup-card">
                    <h6 className="subcategory-view-popup-title">Subcategory Details</h6>

                    <div className="view-popup-info">

                        {/* Image */}
                        <div className="subcategory-view-image-wrapper">
                            <img
                                src={
                                    data?.subCategoryImageObject?.uri
                                        ? `${process.env.REACT_APP_API_URL}${data.subCategoryImageObject.uri}`
                                        : "/assets/placeholder.png"
                                }
                                alt="Subcategory"
                                className="subcategory-view-popup-image"
                            />
                        </div>

                        {/* Details */}
                        <div className="subcategory-info">
                            <table className="subcategory-info-table">
                                <tbody>
                                    <tr>
                                        <th>Category Name</th>
                                        <th>Subcategory Name</th>
                                    </tr>
                                    <tr>
                                        <td>{data.categoryId?.name || data.categoryId?.categoryName || "N/A"}</td>
                                        <td>{data.subCategoryName || data.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Button */}
                        <div className="subcategory-view-action">
                            <button className="subcategory-Done-Button" onClick={onClose}>Close</button>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );

};

export default ViewsubCategoryPopup;